import React, { Fragment } from 'react';
import { Form, Select } from 'antd';
import QuestionPopup from '../../../../../../common/components/questionPopup/questionPopup';
import { attachedDriversPopup } from '../contentsForPopover';
import ShowModal from '../../modal/showModal/ShowModal';
import employeesConnect from '../../../../../../common/hoc/employeesConnect';

const FixedDrivers = ({ form, disabled, profiles }) => {
  const { getFieldDecorator, getFieldValue } = form;
  const values = getFieldValue('fixedDrivers');
  return (
    <Fragment>
      <span className="label">Закрепленные водители:</span>
      <Form.Item>
        {getFieldDecorator('fixedDrivers')(
          <Select
            mode="multiple"
            dropdownClassName="select select_multiple"
            maxTagCount={1}
            placeholder="Выберите водителей"
            className="longInput"
            disabled={disabled}
            showArrow
            getPopupContainer={trigger => trigger.parentNode}
          >
            {profiles &&
              profiles.map((item, index) => (
                <Select.Option value={item.profileId} key={item.profileId}>
                  {item.userName}
                </Select.Option>
              ))}
          </Select>
        )}
      </Form.Item>
      {disabled ? (
        <ShowModal
          title="Закрепленные водители"
          content={profiles}
          keys={values}
          type="profiles"
        />
      ) : (
        <QuestionPopup
          title="Закрепленные водители"
          width="24px"
          height="24px"
          trigger="click"
          fill="#00a8ff"
        >
          {attachedDriversPopup}
        </QuestionPopup>
      )}
    </Fragment>
  );
};

export default employeesConnect(FixedDrivers, ['driver']);
